import Backbone from 'backbone';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',
  template() {
    return `<div class="view_select"></div>`;
  },
  initialize(o) {
    _.bindAll(this, 'handleNumberMessChange');
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  handleNumberMessChange(number) {
    const { $el } = this;
    if (number > 0) {
      this.numberMessEl &&
        this.numberMessEl
          .html(`<div class="numberText">${number}</div>`)
          .css('display', 'block');
    } else {
      this.numberMessEl && this.numberMessEl.html('').css('display', 'none');
    }
  },

  show() {
    const { $el, conf } = this;
    const bottom = conf.size_icon + 35;
    $el.css({ opacity: 1, bottom: `${bottom}px`, display: 'block' });
  },

  hide() {
    const { $el } = this;
    $el.css({ opacity: 0, bottom: '85px' });

    setTimeout(() => {
      $el.css({ display: 'none' });
    }, 150);
  },

  render() {
    const { $el, model, conf } = this;
    const chat_bubbles = `${this.conf.domain}img/livechat_widget.svg`;
    const iconMessage = `${this.conf.domain}img/icon-messenger-not-bg.svg`;

    $el.attr({ class: `${this.pfx}select` }).css('opacity', 0);
    $el.html(this.template());

    this.container = $el.find('.view_select');
    const pos =
      conf.chat_box_position === 7 || conf.chat_box_position === 4
        ? 'left'
        : 'right';
    for (let index = 0; index < conf.widget_config.arrIndex.length; index++) {
      const element = conf.widget_config.arrIndex[index];
      switch (element) {
        case 'mess':
          this.container.append(`<div class="btnMess" ${
            pos === 'left' ? `style="justify-content: flex-start;"` : ''
          } >
                                    ${
                                      pos === 'left'
                                        ? `<div class="viewMess"> 
                                            <img style="width: 40px; height: 40px;" src="${iconMessage}">
                                        </div> 
                                        <div class="viewSelect-tooltip mf" style="margin-left: 8px; margin-right: 0px;">Messenger</div>
                                      `
                                        : `<div class="viewSelect-tooltip mf">Messenger</div>
                                        <div class="viewMess"> 
                                            <img style="width: 40px; height: 40px;" src="${iconMessage}">
                                        </div>   
                                      `
                                    }
                                <div>`);
          break;
        case 'chat':
          this.container.append(`<div class="btnChatTool" ${
            pos === 'left' ? `style="justify-content: flex-start;"` : ''
          }>
                                  ${
                                    pos === 'left'
                                      ? `<div class="viewChat"> 
                                        <div class="numberMess"></div>
                                        <img style="width: 30px; height: 30px;" src="${chat_bubbles}">
                                      </div> 
                                      <div class="viewSelect-tooltip mf" style="margin-left: 8px; margin-right: 0px;">Live chat</div>
                                    `
                                      : `<div class="viewSelect-tooltip mf">Live chat</div>
                                      <div class="viewChat"> 
                                        <div class="numberMess"></div>
                                        <img style="width: 30px; height: 30px;" src="${chat_bubbles}">
                                      </div>   
                                    `
                                  }
                                </div>`);
          break;
      }
    }
    $el.find('.viewChat').css('background-color', this.conf.header_color);
    $el
      .find('.viewMess')
      .css('background-color', this.conf.messenger_config.frame_color);

    this.numberMessEl = $el.find('.numberMess');

    if (pos === 'left') {
      $el.css({ left: '24px', right: 'auto' });
    }

    $el.find('.btnMess').on('click', function(e) {
      if (conf.isTypeShow === 'podFBAndChat') {
        model.trigger('btnMess');
      } else if (conf.isTypeShow === 'tabFBAndChat') {
        window.open(conf.urlFB);
      }
    });

    $el.find('.btnChatTool').on('click', function(e) {
      model.trigger('handleClickChat');
    });

    return this;
  }
});
